import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-eorange-500 to-eorange-400 text-white rounded-t-2xl sm:rounded-t-2xl" };
const _hoisted_2 = { class: "flex-1 min-w-0" };
const _hoisted_3 = { class: "font-semibold text-sm leading-tight" };
const _hoisted_4 = {
    key: 0,
    class: "text-xs text-white/80 leading-tight truncate"
};
const _hoisted_5 = {
    key: 1,
    class: "text-xs text-white/80 flex items-center gap-1"
};
const _hoisted_6 = { class: "flex items-center gap-1" };
const _hoisted_7 = ["aria-label"];
const _hoisted_8 = ["aria-label"];
import { IconX, IconMinus } from '@tabler/icons-vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatHeader',
    props: {
        isWelcome: { type: Boolean }
    },
    emits: ["close", "minimize"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-shrink-0 w-10 h-10 bg-white rounded-full flex items-center justify-center" }, [
                    _createElementVNode("span", { class: "text-eorange-500 font-bold text-lg" }, "E")
                ], -1)),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("chatbot.auto.asistente_emanta")), 1),
                    (__props.isWelcome)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("chatbot.auto.estamos_aqui_para_ayudarte_con_cualquier_consult")), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_5, [
                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "w-1.5 h-1.5 bg-egreen-500 rounded-full inline-block" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t("chatbot.auto.en_linea")), 1)
                        ]))
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "flex-shrink-0 p-1 rounded-full hover:bg-white/20 transition-colors",
                        "aria-label": _ctx.$t('chatbot.auto.minimizar_chat'),
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('minimize')))
                    }, [
                        _createVNode(_unref(IconMinus), { size: 20 })
                    ], 8, _hoisted_7),
                    _createElementVNode("button", {
                        type: "button",
                        class: "flex-shrink-0 p-1 rounded-full hover:bg-white/20 transition-colors",
                        "aria-label": _ctx.$t('chatbot.auto.cerrar_chat'),
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
                    }, [
                        _createVNode(_unref(IconX), { size: 20 })
                    ], 8, _hoisted_8)
                ])
            ]));
        };
    }
});
